<div class="card-body">
    <div id="apex-column-with-data-labels"></div>
</div>